import React, { useState } from "react";
import PropTypes from 'prop-types';
import * as S from "./Carousel.Style";
import { ReactComponent as Arrow } from "../../../assets/images/habitacional/arrow-icon.svg";

const Carousel = ({ children }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleNext = () => {
        setActiveIndex((state) => (state + 1) % children.length);
    };

    const handlePrev = () => {
        setActiveIndex((state) =>
            state === 0 ? children.length - 1 : state - 1
        );
    };

    return (
        <S.CarouselContainer>

            {children.map((child, index) => (
                <S.Slide
                    id={`slide-${index}`}
                    key={`slide-${index}`}
                    isVisible={index === activeIndex}
                >
                    {child}
                </S.Slide>
            ))}

            <S.Navigation>
                <S.NavigationButton direction="left" onClick={handlePrev}>
                    <Arrow />
                </S.NavigationButton>
                <S.IndicatorWrapper>
                    {children.map((_, index) => (
                        <S.Indicator
                            key={index}
                            isActive={index === activeIndex}
                        />
                    ))}
                </S.IndicatorWrapper>
                <S.NavigationButton direction="right" onClick={handleNext}>
                    <Arrow />
                </S.NavigationButton>
            </S.Navigation>
        </S.CarouselContainer>
    );
};

export default Carousel;

Carousel.propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
};